// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.63.0',
  commit: 'c5c04d4a5e52a6e26db11728e8b05f80973b12cd',
  branch: 'platinum',
  dateGenerated: '2026-04-14T15:50:38.291Z',
};